"use client";

import { useEffect, useRef, useState } from "react";

/**
 * KAN-306: гейт для скелетонов — «delay-in + min-out».
 * Мгновенные ответы (Postgres) не мелькают скелетоном вовсе: он появляется,
 * только если загрузка длится дольше `delayMs`; а если уж показан — держится
 * минимум `minVisibleMs`, чтобы подмена контента не выглядела рваной.
 */
export function useDelayedLoading(
  isLoading: boolean,
  { delayMs = 180, minVisibleMs = 350 }: { delayMs?: number; minVisibleMs?: number } = {},
): boolean {
  const [showSkeleton, setShowSkeleton] = useState(false);
  const showSkeletonRef = useRef(false);
  showSkeletonRef.current = showSkeleton;
  const shownAtRef = useRef<number>(0);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    if (isLoading) {
      timer = setTimeout(() => {
        shownAtRef.current = Date.now();
        setShowSkeleton(true);
      }, delayMs);
    } else if (showSkeletonRef.current) {
      const remaining = minVisibleMs - (Date.now() - shownAtRef.current);
      if (remaining <= 0) {
        setShowSkeleton(false);
      } else {
        timer = setTimeout(() => setShowSkeleton(false), remaining);
      }
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isLoading, delayMs, minVisibleMs]);

  return showSkeleton;
}
